var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup161(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_linear_75_2364)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_2364)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_75_2364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1438 24.623C23.0819 23.7831 23.0646 22.9406 23.0918 22.0989L23.0908 22.1359C23.843 21.3561 24.3122 20.3467 24.4233 19.2689L24.4253 19.2479C24.7642 19.2199 25.299 18.89 25.4549 17.5825C25.502 17.3573 25.4842 17.1234 25.4037 16.9079C25.3232 16.6924 25.1833 16.5041 25.0001 16.365L24.9971 16.363C25.5489 14.7036 26.6945 9.56943 22.8769 9.03962C22.484 8.34987 21.4784 8 20.1708 8C14.9397 8.09597 14.309 11.9496 15.4526 16.363C15.2679 16.5034 15.1271 16.6935 15.0465 16.9111C14.966 17.1287 14.9491 17.3647 14.9977 17.5915L14.9967 17.5835C15.1567 18.889 15.6875 19.2209 16.0264 19.2489C16.1452 20.3387 16.6293 21.3561 17.3999 22.1359C17.4252 22.9923 17.4058 23.8495 17.3419 24.7039L17.3469 24.623C16.3092 27.4059 9.32379 26.6242 9.00391 31.9913H31.4537C31.1319 26.6242 24.1784 27.4059 23.1428 24.623H23.1438Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_75_2364",
    x: 7.00391,
    y: 8,
    width: 26.4497,
    height: 27.9912,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_75_2364"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_75_2364",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_2364",
    x1: 20,
    y1: -4.8,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CFFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00706E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_2364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 23.9913,
    fill: "white",
    transform: "translate(9 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup161);
export default __webpack_public_path__ + "static/media/group161.20bbbc4810cca754b30e555fb4b8d450.svg";
export { ForwardRef as ReactComponent };